export const CHICKLET_NONE = 'None';
export const ADD_CHICKLET = 'AddChicklet';
export const ADD_CHICKLET_SINGLE = 'AddChickletSingle';
export const ADD_CHICKLET_SINGLE_REGARDLESS_OF_TYPE = 'AddChickletSingleRegardlessOfType';
export const ASC = 'asc';
export const DESC = 'desc';
export const NON_SELECTED = -1;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
export const ENTER = 13;
export const ESCAPE = 27;
export const DELETE = 8;
export const LAST_POSITION = 1;
export const FIRST_POSITION = -1;
export const MIDDLE_POSITION = 0;
export const CHICKLET_ORANGE = 'orange';
export const CUSTOM_OPTION = 'CUSTOM_OPTION';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SHOW_AUTOCOMPLETE = 'SEARCH';
export const HIDE_AUTOCOMPLETE = 'HIDE';
export const ANY = 'Any';
export const USER_SPECIFIED_OPTION = 'CUSTOM';
export const KD_COUNTRY = 'KdCountry';
export const KD_STATE = 'KdState';
export const KD_CITY = 'KdCity';
export const DATE_FORMAT_WITH_HOUR = 'MM/DD/YYYY hh:mm a';
export const DATE_FORMAT_SIMPLE = 'MM/DD/YYYY';



// WEBPACK FOOTER //
// ./app/constants.js